import { render, staticRenderFns } from "./StudioOptIn.vue?vue&type=template&id=37edf340&scoped=true&"
import script from "./StudioOptIn.vue?vue&type=script&lang=js&"
export * from "./StudioOptIn.vue?vue&type=script&lang=js&"
import style0 from "./StudioOptIn.vue?vue&type=style&index=0&id=37edf340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37edf340",
  null
  
)

export default component.exports